import React, { useEffect, useState } from 'react';
import { Checkbox, Typography } from 'antd';
import clsx from 'clsx';

const BingAdsAccountSetup = ({ onChange }) => {
  const [create, setCreate] = useState({
    track_account: true,
    track_campaigns: true,
    track_ads: true,
  });

  const handleChange = (e) => {
    setCreate((prev) => ({
      ...prev,
      [e.target.name]: e.target.checked,
    }));
  };

  useEffect(() => {
    onChange && onChange(create);
  }, [create]);

  return (
    <div>
      <Typography.Paragraph>
        MyDataNinja recomends some settings in your account properly and well optimized, you can
        choose which steps to follow to optimize your account for MyDataNinja
      </Typography.Paragraph>
      <div className='flex flex-col'>
        <div className='flex gap-2 items-center'>
          <Checkbox onChange={handleChange} name='track_account' checked={create.track_account} />
          <Typography.Paragraph
            className={clsx('!mb-0 mt-1', {
              'line-through': !create.track_account,
            })}
          >
            Enable auto tracking for Ad Accounts
          </Typography.Paragraph>
        </div>
        <div className='flex gap-2 items-center'>
          <Checkbox
            onChange={handleChange}
            name='track_campaigns'
            checked={create.track_campaigns}
          />
          <Typography.Paragraph
            className={clsx('!mb-0 mt-1', {
              'line-through': !create.track_campaigns,
            })}
          >
            Enable auto tracking for Campaigns
          </Typography.Paragraph>
        </div>
        <div className='flex gap-2 items-center'>
          <Checkbox onChange={handleChange} name='track_ads' checked={create.track_ads} />
          <Typography.Paragraph
            className={clsx('!mb-0 mt-1', {
              'line-through': !create.track_ads,
            })}
          >
            Enable auto tracking for Ads
          </Typography.Paragraph>
        </div>
      </div>
    </div>
  );
};

export default BingAdsAccountSetup;
